import React, { useState } from 'react'
import SchoolIcon from '@material-ui/icons/School';
import WorkIcon from '@material-ui/icons/Work';
import "../styles/Experience.css" 

function Experience() {
  const [activeTab, setActiveTab] = useState('all');

  const experiences = [
    {
      type: 'work',
      title: 'Data Scientist',
      company: 'Amazon',
      location: 'Seattle, WA',
      date: 'Dec 2025 - Present',
      highlights: []
    },
    {
      type: 'work',
      title: 'Graduate Assistant Researcher',
      company: 'Texas A&M University',
      location: 'College Station, TX',
      date: 'Dec 2024 - Dec 2025',
      highlights: [
        '{NLP, Video, STT, TTS} projects in Atmospheric & Material Science',
        'MQTT with Agentic AI for large scale IoT data processing',
        'Multi-Agentic and RAG systems for  merging knowledge from multiple sources',
        'Research Paper on "Thinktank: A framework for generalizing domain specific agents" on Arxiv',
      ]
    },
    {
      type: 'work',
      title: 'Data Scientist Intern',
      company: 'Amazon',
      location: 'Bellevue, WA',
      date: 'May 2025 - Aug 2025',
      highlights: [
        'Built Computer Vision utility for advanced warehouse analytics',
        'Researched LLM agent-driven simulations with fatigue modelling (Paper accepted to AFSS 2025)'
      ]
    },
    {
      type: 'work',
      title: 'Student Research Assistant',
      company: 'Texas A&M University',
      location: 'College Station, TX',
      date: 'Oct 2024 - Dec 2024',
      highlights: [
        'Working with Prof. Jian Tao at Digital Twin Lab on LLMs & agentic RAG applications'
      ]
    },
    {
      type: 'work',
      title: 'Data Scientist Intern',
      company: 'Mahindra Group, Group Technology Office',
      location: 'India',
      date: 'Aug 2023 - May 2024',
      highlights: [
        'Data Science and ML initiatives for Mahindra Research Valley'
      ]
    },
    {
      type: 'work',
      title: 'Data Science Intern',
      company: 'VentraGate Technologies',
      location: 'India',
      date: 'Aug 2022 - Oct 2022',
      highlights: [
        'Automated video processing and object detection of fish in videos from camera mounted on a boat'
      ]
    },
    {
      type: 'work',
      title: 'Freelancer',
      company: 'Self-Employed',
      location: 'Remote',
      date: 'Oct 2021 - Jan 2023',
      highlights: [
        'Designed and Developed Websites using MERN stack',
        'Used Computer Vision to solve real-world problem for US fisheries company',
        'Built Discord Bots'
      ]
    },
    {
      type: 'education',
      title: 'Master of Science, Data Science',
      company: 'Texas A&M University',
      location: 'College Station, TX',
      date: 'Aug 2024 - Dec 2025',
      highlights: [
        'GPA: 4.0/4.0',
        'Travel grant Award, 2024, 2025',
        'Graduate Assistantship, 2025'
      ]
    },
    {
      type: 'education',
      title: 'Bachelor of Engineering, Information Science',
      company: 'NMIT, VTU',
      location: 'Bangalore, India',
      date: 'Dec 2020 - May 2024',
      highlights: [
        'GPA: 9.22/10',
        '6th Rank in Engineering, 2024'
      ]
    }
  ];

  const filteredExperiences = activeTab === 'all' 
    ? experiences 
    : experiences.filter(exp => exp.type === activeTab);

  return (
    <div className='experience' id="experience">
      <div className="experience-header">
        <h1>Experience & Education</h1>
        <div className="experience-tabs">
          <button 
            className={activeTab === 'all' ? 'active' : ''} 
            onClick={() => setActiveTab('all')}
          >
            All
          </button>
          <button 
            className={activeTab === 'work' ? 'active' : ''} 
            onClick={() => setActiveTab('work')}
          >
            Work
          </button>
          <button 
            className={activeTab === 'education' ? 'active' : ''} 
            onClick={() => setActiveTab('education')}
          >
            Education
          </button>
        </div>
      </div>
      
      <div className="experience-grid">
        {filteredExperiences.map((exp, index) => (
          <div key={index} className={`experience-card ${exp.type}`}>
            <div className="experience-card-header">
              <div className="experience-icon">
                {exp.type === 'education' ? <SchoolIcon /> : <WorkIcon />}
              </div>
              <div className="experience-title-section">
                <h3>{exp.title}</h3>
                <p className="company">{exp.company}</p>
                <p className="location">{exp.location}</p>
              </div>
            </div>
            <div className="experience-date">{exp.date}</div>
            <ul className="experience-highlights">
              {exp.highlights.map((highlight, idx) => (
                <li key={idx}>{highlight}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Experience
